import React from 'react'
import { useParams } from 'react-router-dom'

import { Panel } from 'rsuite'

import ShopSlotForm from '@components/shop/slot/ShopSlotForm'

export default function EditShopSlotPage () {
  const { shopId, brandSlug, slotId } = useParams<any>()

  return (
    <div className="MakeOrderPage">
      <h1 className="u-heading">Редактирование слотов магазина #{shopId}</h1>
      <Panel shaded>
        <ShopSlotForm slotId={slotId} />
      </Panel>
    </div>
  )
}